<template>
    <div id="benefits">
        <!--=====================================-->
        <!--=       Why Choose Area Start       =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="why-choose-us">
                            <div class="section-heading heading-left mb-0">
                                <span class="subtitle primary">Beneficios</span>
                                <h2 class="font-weight-100">¿Por qué elegir <span class="bold">RedGirasol</span>?</h2>
                            </div>
                            <div class="accordion" id="choose-accordion">
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            <span class="icon edit"></span> Traje a la medida
                                        </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse show"
                                        aria-labelledby="headingOne" data-bs-parent="#choose-accordion">
                                        <div class="accordion-body">
                                            Diseñamos esquemas de pago de acuerdo a las necesidades de tu negocio
                                            (sin enganche, periodo de gracia, amortización a final de plazo, etc).
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingTwo">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                            <span class="icon like"></span>Te queremos financiar
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" class="accordion-collapse collapse show"
                                        aria-labelledby="headingTwo" data-bs-parent="#choose-accordion">
                                        <div class="accordion-body">
                                            Buscamos cómo sí autorizar tu crédito. <br>
                                            Contamos con metodologías de riesgo alternativas.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingThree">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseThree" aria-expanded="true"
                                            aria-controls="collapseThree">
                                            <span class="icon clock"></span></i>Rapidez
                                        </button>
                                    </h2>
                                    <div id="collapseThree" class="accordion-collapse collapse show"
                                        aria-labelledby="headingThree" data-bs-parent="#choose-accordion">
                                        <div class="accordion-body">
                                            Preaprueba tu crédito en minutos. <br>
                                            Autorizamos tu solicitud en 24 horas.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingFour">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseFour" aria-expanded="true"
                                            aria-controls="collapseFour">
                                            <span class="icon pc"></span>Digital
                                        </button>
                                    </h2>
                                    <div id="collapseFour" class="accordion-collapse collapse show"
                                        aria-labelledby="headingFour" data-bs-parent="#choose-accordion">
                                        <div class="accordion-body">
                                            Experiencia en 100% digital durante todo el proceso, desde la solicitud hasta la
                                            firma de los contratos.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-5 col-lg-6 offset-xl-1 mt--150">
                        <div class="why-choose-us mb--30">
                            <div class="why-choose-thumb">
                                <img :src="getImg" alt="Office">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "Benefits",
    props: ["img"],
    components: {
    },
    computed: {
        getImg() {
            if(this.img) {
                return this.img;
            } else {
                return "https://cdn.redgirasol.com/nuevo_portal/extras/extra-sunflower.png";
            }
        }
    }
}

</script>

<style scoped>
.container {
    padding: 3rem;

}

.icon {
    height: 20px;
    width: 20px;
    display: block;
    background-size: 20px !important;
    background-repeat: no-repeat !important;
    margin-right: 10px;
}

    .edit {
        background: url("https://cdn.redgirasol.com/nuevo_portal/icons/icon-edit-01.png");
    }
    .like {
        background: url("https://cdn.redgirasol.com/nuevo_portal/icons/icon-like-02.png");
    }
    .clock {
        background: url("https://cdn.redgirasol.com/nuevo_portal/icons/icon-clock-03.png");
    }
    .pc {
        background: url("https://cdn.redgirasol.com/nuevo_portal/icons/icon-pc-04.png");
    }
</style>